import React from 'react';

export default function GreetingComponent() {
  return <div>Welcome!</div>;
}
